import { AssetPath } from '@gnsx/genesys.js';

import type { AssetHandler } from '../../assetTypes';
import type { IAssetFile } from '../assetHandler';
import type { DropPayload } from '@/editor/core/dragDropTypes';
import type * as THREE from 'three';

import { store } from '@/app/editor/store';
import { globalStore } from '@/app/globalStore';
import * as editorActions from '@/editor/core/actions/editorActions';
import { loadScene } from '@/editor/core/sceneHandler';


/**
 * Handler for scene assets (.genesys-scene files)
 */
export class SceneHandler implements AssetHandler {
  async handleSelect(asset: IAssetFile): Promise<void> {
    store.setSelectedAssetItem(asset);
  }

  async handleOpen(asset: IAssetFile): Promise<void> {
    globalStore.showLoadingOverlay('switchScene', { message: 'Loading Scene...' });
    // save current scene before switching to a new one
    await editorActions.editorSave();
    await loadScene(AssetPath.fromString(asset.path), false, { recreateCanvas: true });
    globalStore.hideLoadingOverlay('switchScene');
  }

  async handleDragEnter(worldPosition: THREE.Vector3, payload: DropPayload): Promise<void> {
  }

  async handleDragOver(worldPosition: THREE.Vector3, payload: DropPayload): Promise<void> {
  }

  async handleDragCancel(worldPosition: THREE.Vector3, payload: DropPayload): Promise<void> {
  }

  async handleDrop(worldPosition: THREE.Vector3, payload: DropPayload): Promise<void> {
    const asset = payload.payload;
    await this.handleOpen(asset);
  }

  getTargetObject(): unknown {
    return undefined;
  }
}